import React from "react";
import LayoutWrapper from "./components/layout/LayoutWrapper";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
const AppWrapper = () => {
  const isAuth = useSelector((state) => state.auth.isAuthenticated);
  // return (
  //   <LayoutWrapper>
  //     <Outlet />
  //   </LayoutWrapper>
  // );
  return isAuth ? (
    <LayoutWrapper>
      <Outlet />
    </LayoutWrapper>
  ) : (
    <Navigate to="login" />
  );
};

export default AppWrapper;
